
import bus from '../../../javascript/bus'
import Toast from 'vux/src/components/toast/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'


export default {
name: 'Cpts029',
directives: {
TransferDom
},
components: {
Toast,
Confirm
},
props: {
params: Object,
passWord: Object
},
data() {
return {
token: bus.userInfo.access_token,
isLogin: Boolean(bus.userInfo.access_token),
collect:{},
toast: {
text: '',
show: false
},
show: false
}
},
mounted() {
this.init()
},
watch: {
params:{
handler(newValue, oldValue) {
this.init()
}
}
},
methods: {
init () {
/* 判断该条内容是否被收藏 */
if(this.isLogin){
this.$http.get('/collection/exist?token='+ this.token + '&title='+ encodeURI(this.params.title ? this.params.title : this.params.name) + '&url='+ encodeURIComponent(this.passWord.articleSite) ).then((response) => {
this.$set(this, 'collect', response.data)
})
}
},
collectItem () {
if (this.isLogin) {
if (this.collect.status === 0) {
const param = {
catalog: Number(this.passWord.collTypes),
isDelete: 0,
picUrl: (this.params.titleImageUrl ? this.params.titleImageUrl : this.params.titleImage) ? (this.params.titleImageUrl ? this.params.titleImageUrl : this.params.titleImage) : this.passWord.picUrl,
serviceType: this.params.serviceType,
summary: (this.params.summary == null) ? this.params.subTitle : this.params.summary,
title: this.params.title ? this.params.title : this.params.name,
url: this.passWord.articleSite,
userId: bus.userInfo.user.id,
username: bus.userInfo.user.username,
deptCode: this.DEPT_CODE.DEPTCODE
}
this.$http.get('/collection/create?token='+ this.token +'&param=' + encodeURIComponent(JSON.stringify(param))).then((response) => {
if (response.data.status === 1) {
this.collect.status = 1
this.toast.text = '收藏成功'
this.toast.show = true
this.init()
}
})
} else {
this.$http.get('/collection/cancel?token='+ this.token +'&id='+ this.collect.data.id ).then((response) => {
if (response.data.status === 1) {
this.collect.status = 0
this.toast.text = '取消收藏'
this.toast.show = true
}
})
}
} else {
this.show = true
}
},
onConfirm() {
this.$router.push({path: '/login?from=collection'})
}
}
}
